import { DtoConstant } from '../gsp-dto-constant';
import { Property, StructuredType } from '@ecp-caf/common-structure';
import { StructureTypeEnum } from '../structure-type-enum';
import { IExtendStrucutreType } from './i-extend-strucutre-type';

export class ExtendStrucutreType extends StructuredType implements IExtendStrucutreType{
    
    constructor(){
        super();
        this.kind=DtoConstant.EXTEND_STRUCTURE_TYPE;
        this.properties=new Array<Property>();
        this.structureType=StructureTypeEnum.CLASS;
    }

    kind:string;
    id: string;
    code: string;
    name: string;
    description: string;
    properties: Property[];
    uri:string;
    structureType: StructureTypeEnum;
    root: boolean;

    getKind(): string {
        return this.kind;
    }
    getKeys(): any[] {
        throw new Error("Method not implemented.");
    }
    getValue(key: any) {
        throw new Error("Method not implemented.");
    }
}